import React, { useState } from "react";
import About from "../About/About";
import Achievements from "../Achievements/Achievements";
import Contact from "../Contact/Contact";
import Projects from "../Projects/Projects";
import Qualifications from "../Qualifications/Qualifications";
import Skills from "../Skills/Skills";
import ShortInfo from "../ShortInfo/ShortInfo";
import './sidebar.css';
import './sidebar.js';
import CodingProfiles from "../CodingProfiles/CodingProfiles";
import Resume from "../Resume/Resume.js";
import Certificate from "../Certificates/Certificate.js";

let currentComponent;
const Home = () => {
    const [activeComponent, setActiveComponent] = useState("ShortInfo");
    // const handleClick = (componentName) => {
    //     setActiveComponent(componentName);
    // };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = 'https://drive.google.com/file/d/1Ip_lihHSleD_MBCNCYIPonQhPffRBW1v/view?usp=sharing';
        // link.download = 'Resume_Dharmesh_Poriya.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (activeComponent === "ShortInfo") {
        currentComponent = <ShortInfo setActiveComponent={setActiveComponent} handleDownload={handleDownload} />;
    } else if (activeComponent === "About") {
        currentComponent = <About />;
    } else if (activeComponent === "Skills") {
        currentComponent = <Skills />;
    } else if (activeComponent === "Projects") {
        currentComponent = <Projects />;
    } else if (activeComponent === "Achievements") {
        currentComponent = <Achievements />;
    } else if (activeComponent === "Qualifications") {
        currentComponent = <Qualifications />;
    } else if (activeComponent === "CodingProfiles") {
        currentComponent = <CodingProfiles />;
    } else if (activeComponent === "Contact") {
        currentComponent = <Contact />;
    } else if (activeComponent === "Resume") {
        currentComponent = <Resume />;
    } else if (activeComponent === "Certificates") {
        currentComponent = <Certificate />;
    }

    return (
        <div id="wrapper">
            <div className="overlay"></div>

            {/* <!-- Sidebar --> */}
            <nav className="navbar navbar-inverse fixed-top" id="sidebar-wrapper" role="navigation">
                <ul className="nav sidebar-nav">
                    <div className="sidebar-header">
                        <div className="sidebar-brand">
                            <button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("ShortInfo") }}>Dharmesh Poriya</button>
                        </div>
                    </div>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("ShortInfo") }}> Home</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("About") }} >About</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Skills") }} >Skills</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Qualifications") }} >Qualifications</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Projects") }} >Projects</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("CodingProfiles") }} >Coding Profiles</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Achievements") }} >Achievements</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Certificates") }} >Certificates</button></li>
                    <li><button className="btn btn-link" style={{ color: 'white', textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Contact") }} >Contact</button></li>
                    <li><button className="button-48" style={{  textDecoration: 'none', width: '100%' }} onClick={() => { setActiveComponent("Resume") }} ><span className="text">Download CV</span></button></li>
                    {/* <li><button className="button-48" style={{  textDecoration: 'none', width: '100%' }} onClick={handleDownload}><span className="text">Download CV</span></button></li> */}

                </ul>
            </nav>
            {/* <!-- /#sidebar-wrapper -->

        <!-- Page Content --> */}
            {
                activeComponent === "ShortInfo" ?
                    <div id="page-content-wrapper" className="bgimage">
                        <button type="button" className="hamburger animated fadeInLeft is-closed" data-toggle="offcanvas">
                            <span className="hamb-top" style={{ backgroundColor: 'white' }}></span>
                            <span className="hamb-middle" style={{ backgroundColor: 'white' }}></span>
                            <span className="hamb-bottom" style={{ backgroundColor: 'white' }}></span>
                        </button>
                        <div className="container w-100">
                            <div className="row">
                                <div className="col-12">
                                    {currentComponent}
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div id="page-content-wrapper">
                        <button type="button" className="hamburger animated fadeInLeft is-closed" data-toggle="offcanvas">
                            <span className="hamb-top"></span>
                            <span className="hamb-middle"></span>
                            <span className="hamb-bottom"></span>
                        </button>
                        <div className="container w-100">
                            <div className="row">
                                <div className="col-12">
                                    {currentComponent}
                                </div>
                            </div>
                        </div>
                    </div>

            }

        </div>
    );
};

export default Home;

/*
return (
        <div className="container border border-danger">
            <nav className="navbar navbar-expand-lg navbar-light">
                <a className="navbar-brand" href="/"><img src={logo} width='80px' alt='logo' /> </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item active">
                            <button className="nav-link btn btn-link"  onClick={() => { setActiveComponent("ShortInfo") }}>Home <span className="sr-only">(current)</span></button>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => { setActiveComponent("About") }}>About</button>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => { setActiveComponent("Skills") }}>Skills</button>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => { setActiveComponent("Projects") }}>Projects</button>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => { setActiveComponent("Achievements") }}>Achievement</button>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => { setActiveComponent("Qualifications") }}>Qualification</button>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => { setActiveComponent("Contact") }}>Contact</button>
                        </li>
                    </ul>
                </div>
            </nav>
            {currentComponent}

            <h1>Footer</h1>
        </div>
    );
*/